var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00585938H513V341.994H0V-0.00585938Z",
    fill: "#3A7DCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7419 86.1835L144.798 129.623L182.032 119.97L197.891 64.119L239.952 39.2964L303.387 48.9496L375.786 86.873L379.923 148.929L403.367 157.204V220.639L358.548 299.933L304.766 316.482L255.121 304.76L267.532 284.075L262.016 262.01L255.121 268.216L143.419 250.978L109.633 192.369L123.423 160.651L89.6371 117.901L82.7419 86.1835Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1646"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00585938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAq);
export default __webpack_public_path__ + "static/media/AQ.865e3cf43b461e55fd09286c27a03e15.svg";
export { ForwardRef as ReactComponent };